import React from 'react';

function ScoutSuggestion({ text }) {
  if (!text) return null;

  return (
    <div className="scout-suggestion">
      <span className="scout-suggestion-icon">💡</span>
      <span className="scout-suggestion-text">{text}</span>
    </div>
  );
}

export default React.memo(ScoutSuggestion);
